import * as React from 'react'; 
import Chart from 'react-apexcharts'; 
import { ApexOptions } from 'apexcharts';

interface Props {
    categories: string[]; 
    clickEvent: (v: any) => void; 
    series: number[]; 
    seriesLabel: string;     
    title: string;     
}
const VerticalBarChart: React.FC<Props> = ({categories, clickEvent, series, seriesLabel, title}) => {
    const options: ApexOptions = {        
        chart: {
            events: {
                dataPointSelection: (event:any, chartContext:any, config:any) => {
                    clickEvent(categories[config.dataPointIndex]); 
                }
            },
            toolbar: { 
                show: true, 
                tools: {
                    download: true,
                    selection: false,
                    zoom: true,
                    zoomin: true,
                    zoomout: true,
                    pan: true,
                    reset: true ,
                    customIcons: []
                }
            },                      
            zoom: {
                enabled: true,
            }
        },
        plotOptions: {
            bar: {
                horizontal: true
            }
        },  
        xaxis: {
        categories: categories
        },
        title: {
            text: title,
            align: 'center',
            margin: 20,
            floating: true, 
            style: {
                fontSize: '20px'
            }
        },
    }; 

    const apexSeries: ApexOptions["series"] = [
        {
            name: seriesLabel,
            data: series
        },
    ]; 

    return (
        <Chart 
            options={options} 
            series={apexSeries} 
            type="bar" 
            height="100%" 
        />
    );
}
    
export default VerticalBarChart; 